import { creatorApiProxyEndpoint } from 'root/src/shared/creatorApi/endpoints/creatorApiProxy';
import { CreatorApiEndpoint } from 'root/src/shared/creatorApi/constants';
export const creatorApiEndpoints = {
    [CreatorApiEndpoint.CREATOR_API_PROXY]: creatorApiProxyEndpoint,
};
